module.exports = __webpack_public_path__ + "img/thumbnails-15-lyrics-search.bd775eab.png";